import { FormattedMessage, useIntl } from 'react-intl'

import {
  OtherLinks,
  StyledLinkRouter,
  StyledLink
} from '../../../../components/form-fields/styled-components'

import { OtherContainer, SingleSignOnWrapper } from '../../styled-components'

import ButtonComponent from '../../../../components/stories/atoms/button'
import {
  buttonSizeOptions,
  buttonVariantOptions
} from '../../../../components/stories/atoms/button/constants'
import { Shovel } from '../../../../components/stories/atoms/icons/versions'
import colorsOptions from '../../../../components/stories/fundamentals/colors-styles/constants'
import { Link } from 'react-router-dom'
import { IntercomLink } from '../../../HelpMenu/intercom'

const LoginFooterLinks = ({ show2FA, isInPopup }) => {
  const { formatMessage } = useIntl()

  const versionString = formatMessage({ id: 'helpMenu_version' })
  return (
    <>
      <OtherContainer>
        {show2FA && (
          <OtherLinks>
            <FormattedMessage id="registerForm_reset2StepAuth" />
            <span>&nbsp;</span>
            <StyledLinkRouter to="/forgotPassword">
              <FormattedMessage id="registerForm_reset2StepAuth" />
            </StyledLinkRouter>
          </OtherLinks>
        )}
        {!show2FA && !isInPopup && (
          <OtherLinks>
            <FormattedMessage id="registerForm_noAcc" />
            <span>&nbsp;</span>
            <ButtonComponent
              variant={buttonVariantOptions.LINK}
              size={buttonSizeOptions.SMALL}
              emphasis={true}
              to={'/register'}
              data-testid="Login-linkToRegister"
            >
              <FormattedMessage id="registerForm_createAccLink" />
            </ButtonComponent>
          </OtherLinks>
        )}
        {!isInPopup && (
          <OtherLinks>
            <FormattedMessage id="registerForm_forgotPassword" />
            <span>&nbsp;</span>
            <ButtonComponent
              variant={buttonVariantOptions.LINK}
              size={buttonSizeOptions.SMALL}
              emphasis={true}
              to="/forgotPassword"
              data-testid="Login-link-forgotPassword"
            >
              <FormattedMessage id="registerForm_resetPassword" />
            </ButtonComponent>
          </OtherLinks>
        )}
        <OtherLinks>
          <FormattedMessage id="registerForm_needHelp" />
          <span>&nbsp;</span>
          <IntercomLink />
        </OtherLinks>
        <OtherLinks>
          <span>
            <span>{versionString}</span>
            <span>:</span>
            <span>&nbsp;</span>
            <Shovel
              style={{
                width: '16px',
                height: '16px',
                stroke: colorsOptions.docuToolsOrange.orange
              }}
            />
            <span>&nbsp;</span>
            <StyledLink as="span">
              <span>{import.meta.env.VITE_VERSION_NAME || 'Tool'}</span>
              <span> – </span>
              <span>{import.meta.env.VITE_REACT_APP_VERSION || '00'}</span>
              {!!import.meta.env.VITE_TARGET_ENV &&
                import.meta.env.VITE_TARGET_ENV !== 'production' && (
                  <span>{import.meta.env.VITE_TARGET_ENV.substring(0, 2)}</span>
              )}
            </StyledLink>
          </span>
        </OtherLinks>
      </OtherContainer>
      <SingleSignOnWrapper>
        <ButtonComponent
          as={Link}
          to="/idpSelection"
          variant={buttonVariantOptions['TERTIARY-HOLLOW']}
          size={buttonSizeOptions.LARGE}
          fullWidth={true}
          style={{ padding: 0 }}
        >
          <FormattedMessage id="singleSignOn_title" />
        </ButtonComponent>
      </SingleSignOnWrapper>
    </>
  )
}

export default LoginFooterLinks
